import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { CategoryService } from "../../Services";
import GalleryService from "../../Services/GalleryService";
import AddGallery from "./AddGallery";
import { RiCloseFill} from "react-icons/ri";
import ReactPaginate from "react-paginate";

let style={
    position: "absolute",
    right: "17px",
    top: "8px",
    color: "white",
    fontSize: "20px",
    background: "red",
    borderRadius: "10px",
}

const Gallery = () => {
  const history = useHistory();
  const [images, setImages] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [loader, setLoader] = useState(false);
  const [asigncat, setAsigncat] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);

  let img_url = process.env.REACT_APP_API_BASEURL;

  const getGalleryimg = async () => {
    setLoader(true);
    let param = { ...pagination, page: currentPage };
    await GalleryService.getGallery(param).then((res) => {
      setLoader(false);
      setPagination({ ...pagination, ...res.pagination });
      setImages(res.data);
    });
  };

  const handleDelete = async () => {
    const obj = {
      id: deleteId,
    };
    await GalleryService.deleteGalleryImage(obj).then((res) => {
      setLoader(true);
      if (res.status) {
        setLoader(false);
        getGalleryimg();
        toast.success(res.message);
        setDeleteModal(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getGalleryimg();
  }, [currentPage]);
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => setAddModal(true)}
            >
              Add Gallery
            </Button>
          </div>
          <div className="row">
            {images &&
              images.map((item, index) => {
                return (
                  <div className="col-sm-3 mt-3 position-relative">
                    <img
                    
                      style={{ width: "100%", height: "300px", border : "2px solid #6ED5C4", }}
                      src={img_url + "/" + item?.image}
                      alt=""
                    />
              <RiCloseFill 
              onClick={() => handleDeleteModal(item._id)} 
              style={style}/>
                  </div>
                );
              })}
          </div>

          <div className="text-center">
                {(loader && <Spinner animation="grow" size="sm" />) || ""}
              </div>
              {images?.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  {/* {/ <Spinner animation="grow" size="sm" /> /} */}
                  {/* {/ <Loader isShow={loader}/> /} */}
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}


              {images &&
                images.length > 0 &&
              pagination.totalRecord > pagination.limit && (
                <ReactPaginate
                  previousLabel={
                    <img
                      src="assets/images/prev.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  forcePage={currentPage - 1}
                  nextLabel={
                    <img
                      src="assets/images/next.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.totalRecord / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(e) => onPageChangeEvent(e)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              )}

          {/* {/ Add Modal /} */}

          <Modal
            show={addModal}
            onHide={() => setAddModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Gallery</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddGallery setAddModal={setAddModal} getGalleryimg={getGalleryimg}/>
              {/* <AddGallery setAddModal={setAddModal} getGalleryimg={getGalleryimg} /> */}
            </Modal.Body>
          </Modal>

          {/* {/ Delete Modal /} */}

          <Modal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete Image</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal(false)}>
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <Modal
            show={asigncat}
            onHide={() => setAsigncat(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Assign Sub Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              abc
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{ zIndex: 9 }}
                type="button"
                // onClick={submitSubcat}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal> */}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
